import Image from "next/image";

export default function Category({ Name, Icon, Click, Active }) {
  return (
    <div className="mt-4 mr-2">
      <button
        onClick={Click}
        className={
          Active
            ? "w-full flex items-center px-4 py-2 transition border-2 border-default shadow-lg dark:shadow-neutral-800 rounded focus:outline-none bg-default bg-opacity-10"
            : "w-full flex items-center px-4 py-2 transition shadow-lg dark:shadow-neutral-800 border-2 border-transparent rounded focus:outline-none"
        }
      >
        {Icon ? (
          <>
            <div className="w-8 h-8 dark:text-white">
              <Image src={Icon} width={32} height={32} alt={Name} />
            </div>
            <p className="ml-4">{Name}</p>
          </>
        ) : (
          <p className="leading-8">{Name}</p>
        )}
      </button>
    </div>
  );
}
